export default __webpack_public_path__ + "static/media/pangongtsolake1.22dbfa02.jpg";